import { Search, CalendarDays } from "lucide-react";
import { DateControls } from "@/components/DateControls";
import FilterBar from "@/components/mobile/FilterBar";

// One shared top bar used IDENTICALLY on the mobile Table, Calendar and Map tabs so the
// controls never shift between views. Layout:
//   Row A — DateControls (‹ month › + Today + range dropdown)
//   Row B — [optional picker] [search]
//   Row C — FilterBar (Filters + Closes 7d + active chips)
// View-specific extras (e.g. the Map's Rodeos/Contestants + Entered toggles) are passed
// as `children` and render in a clearly separate strip below.
export default function MobileViewHeader({
  onSearch,
  searchLabel = "Search rodeos, towns…",
  searchTestid = "m-view-search-open",
  onPicker,
  pickerActive = false,
  pickerIcon: PickerIcon = CalendarDays,
  pickerTestid = "m-view-picker",
  children,
}) {
  return (
    <div className="shrink-0 p-2.5 space-y-2 border-b border-white/10 bg-[#0F141B] max-lg:landscape:hidden" data-testid="m-view-header">
      <DateControls dark />
      <div className="flex items-center gap-1.5">
        {onPicker && (
          <button type="button" onClick={onPicker} data-testid={pickerTestid}
            className={`shrink-0 p-2 rounded-lg border active:bg-white/10 ${pickerActive ? "bg-[#C8000F] border-[#C8000F] text-white" : "bg-white/5 border-white/10 text-slate-300"}`}>
            <PickerIcon className="w-4 h-4" />
          </button>
        )}
        <button type="button" onClick={onSearch} data-testid={searchTestid}
          className="relative flex-1 min-w-0 flex items-center gap-2 text-left rounded-lg border border-white/10 bg-white/5 text-slate-400 pl-9 pr-3 py-2 text-sm active:bg-white/10">
          <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-500" />
          <span className="truncate">{searchLabel}</span>
        </button>
      </div>
      <FilterBar className="w-full" />
      {children}
    </div>
  );
}
